import React from "react";
import {
  GiCompass,
  GiDiamondHard,
  GiStabbedNote,
  GiBriefcase,
} from "react-icons/gi";

export default [
  {
    id: 1,
    icon: <GiCompass className="icon" />,
    label: "mission",
    text:
      " Activated charcoal post-ironic unicorn flexitarian tumeric, direct trade man bun mumblecore kickstarter art party. ",
  },
  {
    id: 2,
    icon: <GiDiamondHard className="icon" />,
    label: "vision",
    text:
      " Brooklyn mustache polaroid neutra. Wolf subway tile gluten-free bushwick, godard letterpress pitchfork direct trade put a bird on",
  },
  {
    id: 3,
    icon: <GiStabbedNote className="icon" />,
    label: "history",
    text:
      "Chia pinterest locavore letterpress tote bag. Subway tile PBR&B knausgaard locavore quinoa four loko disrupt photo booth hella.",
  },
  {
    id: 4,
    icon: <GiBriefcase className="icon" />,
    label: "work",
    text:
      "Man braid banh mi prism disrupt hella cray mlkshk jean shorts typewriter synth salvia direct trade pabst knausgaard.",
  },
];
